var x=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,a=function(a){return a.match(x)||[]};export{a as _};
//# sourceMappingURL=_asciiWords.js.map
